import { useState } from 'react';
import { inUnsererApp } from '@/lib/app/umgebung';

/**
 * Hook to detect if the app is running inside our native app (Web to Native).
 * Used to hide commercial elements (upgrade CTAs, pricing, checkout)
 * for Apple App Store compliance (Reader App model).
 *
 * Seit Sitzung A1 (18.10.2026) über `inUnsererApp()`: erkannt an der Schnittstelle von Web to Native, nicht mehr nur am
 * User-Agent (der hielt auch die Browser in Instagram und Facebook für die App).
 *
 * Only affects native app users – browser users (desktop & mobile) see everything.
 */
export function useIsNativeApp(): boolean {
  const [isNative] = useState(() => inUnsererApp());
  return isNative;
}
